export const MM = 96 / 25.4;

export const PAGE_SIZES = {
  A4: { w: 210, h: 297, label: "A4 · 210 × 297 mm" },
  Letter: { w: 215.9, h: 279.4, label: "US Letter · 8.5 × 11 in" },
};

export const MARGIN_PRESETS = {
  normal: { label: "Normal · 25.4 mm", m: { top: 25.4, right: 25.4, bottom: 25.4, left: 25.4 } },
  narrow: { label: "Narrow · 12.7 mm", m: { top: 12.7, right: 12.7, bottom: 12.7, left: 12.7 } },
  moderate: { label: "Moderate · 25.4 / 19 mm", m: { top: 25.4, right: 19.05, bottom: 25.4, left: 19.05 } },
  wide: { label: "Wide · 25.4 / 50.8 mm", m: { top: 25.4, right: 50.8, bottom: 25.4, left: 50.8 } },
};

export const THEMES = {
  classic: { label: "Classic Office", bg: "#FFFFFF", font: "Calibri, Carlito, 'Open Sans', Arial, sans-serif", heading: "#1F2937", text: "#111827" },
  slate: { label: "Warm Slate", bg: "#FAFAF9", font: "Georgia, 'Times New Roman', serif", heading: "#334155", text: "#1E293B" },
  emerald: { label: "Emerald Press", bg: "#F6FBF7", font: "'Lora', Georgia, serif", heading: "#065F46", text: "#0F2A1F" },
  ivory: { label: "Ivory Paper", bg: "#FDF8EE", font: "'Merriweather', Georgia, serif", heading: "#7C2D12", text: "#292524" },
  mono: { label: "Minimal Mono", bg: "#FFFFFF", font: "'Plus Jakarta Sans', Arial, sans-serif", heading: "#000000", text: "#18181B" },
};

export const FONTS = [
  { label: "Calibri", value: "Calibri, Carlito, 'Open Sans', sans-serif" },
  { label: "Arial", value: "Arial, Helvetica, sans-serif" },
  { label: "Times New Roman", value: "'Times New Roman', Times, serif" },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Courier New", value: "'Courier New', monospace" },
  { label: "Verdana", value: "Verdana, sans-serif" },
  { label: "Open Sans", value: "'Open Sans', sans-serif" },
  { label: "Lora", value: "'Lora', serif" },
  { label: "Merriweather", value: "'Merriweather', serif" },
  { label: "EB Garamond", value: "'EB Garamond', serif" },
  { label: "Source Code Pro", value: "'Source Code Pro', monospace" },
  { label: "Plus Jakarta Sans", value: "'Plus Jakarta Sans', sans-serif" },
  { label: "Caveat", value: "'Caveat', cursive" },
];

export const SIZES = [8, 9, 10, 10.5, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 60, 72];

export const defaultSettings = () => ({
  size: "A4",
  orientation: "portrait",
  margins: { ...MARGIN_PRESETS.normal.m },
  theme: "classic",
  watermark: { text: "", color: "#94A3B8", opacity: 0.18 },
  header: "",
  footer: "",
  pageNumbers: { enabled: false, position: "bottom-center", format: "Page {n} of {total}" },
  tabSize: 48,
  comments: [],
});

export function dims(s) {
  const p = PAGE_SIZES[s.size] || PAGE_SIZES.A4;
  const land = s.orientation === "landscape";
  const wmm = land ? p.h : p.w;
  const hmm = land ? p.w : p.h;
  const m = s.margins;
  return {
    wmm, hmm, w: wmm * MM, h: hmm * MM,
    mt: m.top * MM, mr: m.right * MM, mb: m.bottom * MM, ml: m.left * MM,
    cw: (wmm - m.left - m.right) * MM, ch: (hmm - m.top - m.bottom) * MM,
  };
}

export const themeOf = (s) => THEMES[s.theme] || THEMES.classic;

export const themeVars = (s) => {
  const t = themeOf(s);
  return { "--doc-font": t.font, "--doc-heading": t.heading, "--doc-text": t.text, background: t.bg };
};

export const esc = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const pageNumberText = (fmt, n, total) => fmt.replace("{n}", n).replace("{total}", total);

export const SIG_PLACEHOLDER = '<span class="sig-placeholder">✎ Sign here</span><span class="sig-caption">Signature</span>';
export const OV_UI = '<span class="ov-ui" contenteditable="false"><span class="ov-grip" title="Drag to move">⠿</span><span class="ov-del" title="Remove">×</span></span>';
export const INITIALS_PLACEHOLDER = '<span class="sig-placeholder">✎ Initials</span><span class="sig-caption">Initials</span>';
